export function nestedMapGet(instance, [key, ...restKeys]) {
    if (!instance)
        return undefined;
    const value = instance.get(key);
    if (!restKeys.length) {
        return value;
    }
    return nestedMapGet(value, restKeys);
}
export function nestedMapHas(instance, keys) {
    const lastMap = nestedMapGet(instance, keys.slice(0, keys.length - 1));
    if (!lastMap)
        return false;
    return lastMap.has(keys.slice(-1)[0]);
}
export function nestedMapSet(instance, [key, ...restKeys], value, [MapOrWeakMap, ...restConstructors] = []) {
    if (!instance)
        throw new Error(`[nestedMapSet] instance is not set`);
    let map = instance.get(key);
    if (!map) {
        map = new (MapOrWeakMap ?? Map)();
        instance.set(key, map);
    }
    if (restKeys.length > 1) {
        nestedMapSet(map, restKeys, value, restConstructors);
    }
    else {
        map.set(restKeys[0], value);
    }
}
export function nestedMapDelete(instance, [key, ...restKeys]) {
    if (!instance)
        return false;
    const map = instance.get(key);
    if (!map)
        return false;
    if (restKeys.length === 1) {
        return map.delete(restKeys[0]);
    }
    return nestedMapDelete(map, restKeys);
}
export class NestedMap {
    map;
    dimensionConstructors;
    constructor([FirstConstructor, ...dimensionConstructors] = []) {
        this.map = new (FirstConstructor ?? Map)();
        this.dimensionConstructors = dimensionConstructors;
    }
    delete(keys) {
        return nestedMapDelete(this.map, keys);
    }
    get(keys) {
        return nestedMapGet(this.map, keys);
    }
    has(keys) {
        return nestedMapHas(this.map, keys);
    }
    set(keys, value) {
        nestedMapSet(this.map, keys, value, this.dimensionConstructors);
        return this;
    }
}
//# sourceMappingURL=NestedMap.js.map